module.exports = __webpack_public_path__ + "img/12.b4fd4e7e.png";